import { FC, memo } from 'react';

import usePage from '@Queries/usePage';
import PageWikiRubric, { PageWikiRubricData } from '@Pages/PageWikiRubric';
import TemplateService from '@Templates/TemplateService';

const RouteWikiRubric: FC = () => {
  const page = usePage<PageWikiRubricData>();

  if (!page.isSuccess) return null;

  return (
    <TemplateService
      title={page.data.meta.h1}
      breadcrumbs={page.data.breadcrumbs}
      navigation={page.data.nav.map((item) => ({
        active: item.active,
        name: item.title,
        href: item.link,
      }))}
    >
      <PageWikiRubric page={page.data} />
    </TemplateService>
  );
};

export default memo(RouteWikiRubric);
